import { render, staticRenderFns } from "./pageParagraphItem.vue?vue&type=template&id=0592e190"
import script from "./pageParagraphItem.vue?vue&type=script&lang=js"
export * from "./pageParagraphItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports